import SimpleKeyboardLayouts from "./components/Layouts";
export default SimpleKeyboardLayouts;
